import { render, staticRenderFns } from "./baseinfo.vue?vue&type=template&id=43c77e2a&scoped=true"
import script from "./baseinfo.vue?vue&type=script&lang=js"
export * from "./baseinfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c77e2a",
  null
  
)

export default component.exports